import React from 'react'
import { Hero } from './Hero'

const App: React.FC = () => <Hero />

export default App
